import React from 'react';
import { DatePicker } from 'antd';
import { AddedSection, AddedAttributeType } from 'pages/UserPage/components/MiddlePane/types';
import { Dayjs } from 'dayjs';
import { formatAsDateString } from 'common/utils/time';
import { updateAddedValue, updateValue } from '../../../updateAttributeValueUtils';
import styles from '../AttributeTypeEditField.module.scss';

interface Props {
  addedSections: AddedSection[];
  attributeTypeName: string;
  getDateValue: (attributeTypeName: string) => Dayjs | undefined;
  section: AddedSection;
  setAddedSections: (addedSections: AddedSection[]) => void;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  userAttributeTypes: AddedAttributeType[];
}

const DateEditField = ({
  addedSections,
  attributeTypeName,
  getDateValue,
  section,
  setAddedSections,
  setUserAttributeTypes,
  userAttributeTypes,
}: Props) => (
  <DatePicker
    className={styles.editField}
    onChange={e => {
      if (section.addedSection) {
        updateAddedValue(
          section.name,
          attributeTypeName,
          e && formatAsDateString(e),
          addedSections,
          userAttributeTypes,
          setUserAttributeTypes,
          setAddedSections);
      } else {
        updateValue(
          attributeTypeName,
          e ? { value: formatAsDateString(e) } : null,
          userAttributeTypes,
          setUserAttributeTypes);
      }
    }}
    value={getDateValue(attributeTypeName)}
  />
);

export default DateEditField;
